'use client';

import { useLayoutEffect } from 'react';
import Cookies from 'js-cookie';

import { isClient } from '../../../utilities';

const SESSION_ID_SUFFIX = '_session_id';
const DELETE_PREFIX = 'delete_';

function hasNonEmptySessionPrefix(name: string): boolean {
  return name.endsWith(SESSION_ID_SUFFIX) && name.length > SESSION_ID_SUFFIX.length;
}

function isSessionIdParamName(name: string): boolean {
  return !name.startsWith(DELETE_PREFIX) && hasNonEmptySessionPrefix(name);
}

function isDeleteSessionIdParamName(name: string): boolean {
  if (!name.startsWith(DELETE_PREFIX)) {
    return false;
  }

  const sessionCookieName = getSessionCookieNameFromDeleteParamName(name);
  return hasNonEmptySessionPrefix(sessionCookieName);
}

function getSessionCookieNameFromDeleteParamName(name: string): string {
  return name.slice(DELETE_PREFIX.length);
}

const useAviosAuthCookieManager = () => {
  useLayoutEffect(() => {
    if (!isClient()) return;

    const queryParams = new URLSearchParams(window.location.search);
    const paramNames = Array.from(queryParams.keys());

    const sessionIdParamName = paramNames.find((name) => isSessionIdParamName(name));
    const deleteSessionIdParamName = paramNames.find((name) => isDeleteSessionIdParamName(name));

    const sessionIdToken = sessionIdParamName ? queryParams.get(sessionIdParamName) : null;

    if (deleteSessionIdParamName) {
      const cookieName = getSessionCookieNameFromDeleteParamName(deleteSessionIdParamName);
      Cookies.remove(cookieName);
    } else if (sessionIdParamName && sessionIdToken) {
      Cookies.set(sessionIdParamName, sessionIdToken, { expires: 7, secure: true });
    }

    if (sessionIdParamName || deleteSessionIdParamName) {
      window.history.replaceState(window.history.state, document.title, window.location.pathname);
    }
  }, []);
};

export { useAviosAuthCookieManager };
